module.exports = __webpack_public_path__ + "static/media/zanders.08c0a16b.png";